import { db } from '../index';
import { safraMapper } from '../schemas/SafraSchema';

class SafraRepository {
  async findAll() {
    return await db.safras.toArray();
  }

  async bulkUpsert(apiData) {
    const entities = safraMapper.toEntity(apiData);

    return await db.transaction('rw', db.safras, async () => {
      await db.safras.clear(); // Limpa antes para evitar duplicatas
      return await db.safras.bulkAdd(entities); // ← bulkAdd para auto-incremento
    });
  }

  async getLastUpdate() {
    const last = await db.safras.orderBy('updatedAt').last();
    return last ? last.updatedAt : null;
  }

  async clear() {
    return await db.safras.clear();
  }

  async needsRefresh(maxAge = 30 * 24 * 60 * 60 * 1000) {
    const lastUpdate = await this.getLastUpdate();
    if (!lastUpdate) return true;

    return (Date.now() - lastUpdate) > maxAge;
  }
}

export const safraRepository = new SafraRepository();
